import React from 'react';
import { SmartButtonOutlined } from '@mui/icons-material';
import { Button, ButtonPropsSchema } from './Button';
import ButtonSidebarPanel from './ButtonSidebarPanel';
export default {
    label: 'Button',
    icon: React.createElement(SmartButtonOutlined, null),
    type: 'Button',
    defaultData: {
        props: {
            fullWidth: false,
            size: 'medium',
            text: 'Button',
            url: 'https://www.usewaypoint.com',
            buttonStyle: 'rounded',
            buttonTextColor: '#FFFFFF',
            buttonBackgroundColor: '#999999',
        },
        style: {
            fontSize: 16,
            fontWeight: 'bold',
            padding: { top: 16, bottom: 16, left: 24, right: 24 }
        },
    },
    SidebarPanel: ButtonSidebarPanel,
    Component: Button,
    schema: ButtonPropsSchema,
};
//# sourceMappingURL=index.js.map